const $ = window.jQuery;
import "bootstrap";


$(function () {
	let cast_creative = $(".cast-creative-staff");
	cast_creative.on("click", function (e) {
		let $this = $(this);
		e.preventDefault();

		if ($this.find(".bio").length == 0) {
			return;
		}

		if ($this.hasClass("cc_popup")) {
			let bio_html = $(".bio_html", $this).html();
			$("#ccModal .modal-body").html(bio_html);
			let bioModal = new bootstrap.Modal(document.getElementsByClassName("bio"), {});
			bioModal.show();
		} else {
			let parentContainer = $(this).closest(".row");
			// clone Bio Content to full width viewer
			let bio = $(this).find(".bio").clone();
			if ($(this).hasClass("active")) {
				$(this).removeClass("active");

				$(".full-width-viewer").slideUp(function () {
					$(this).remove();
				});
			} else {
				cast_creative.removeClass("active");
				$(this).addClass("active");
				$(".full-width-viewer").remove();
				parentContainer
					.after('<div class="full-width-viewer text-center py-2 py-lg-3 mb-lg-6"><article><header class="py-4"></header><footer></footer></article></div>')
					.promise()
					.done(function () {
						$(".full-width-viewer article footer").html(bio);
						$(".full-width-viewer article footer bio").removeClass("d-none");
						$(".full-width-viewer article header").html('<i class="fas fa-times text-white fs-32"></i>');
						$(".full-width-viewer").slideDown();
						$("html,body").animate(
							{
								scrollTop: $(".full-width-viewer").offset().top - $('header[role="main"]').innerHeight(),
							},
							500
						);
					});
			}
		}

		
	});

	if (cast_creative) { 
		// Check if there's a hash in the URL
		if (window.location.hash) {
		var hash = window.location.hash;
		var triggerEl = document.querySelector('a[href="' + hash + '"]');
		if (triggerEl) {
			var tab = new bootstrap.Tab(triggerEl);
			tab.show();
		}
		}
	
		// Update the URL hash as user clicks on the tab
		var triggerTabList = [].slice.call(document.querySelectorAll('a[data-bs-toggle="tab"], a[data-bs-toggle="pill"]'));
		triggerTabList.forEach(function (triggerEl) {
		triggerEl.addEventListener('shown.bs.tab', function (event) {
			var targetHash = event.target.getAttribute('href');
			if (targetHash) {
			history.replaceState(null, null, targetHash);
			}
		});
		});
	}
	

	$("body").on("click", ".full-width-viewer article header .fa-times", function (e) {
		e.preventDefault();
		cast_creative.removeClass("active");
		$(".full-width-viewer").slideUp(function () {
			$(this).remove();
		});
	});
});
